export default "__VITE_ASSET__Qc6X5bxQ__"